import * as RadixSwitch from '@radix-ui/react-switch';
import { type ComponentPropsWithoutRef, type ElementRef, forwardRef } from 'react';
import { cn } from '../lib/utils.js';

export const Switch = forwardRef<
  ElementRef<typeof RadixSwitch.Root>,
  ComponentPropsWithoutRef<typeof RadixSwitch.Root>
>(({ className, ...props }, ref) => (
  <RadixSwitch.Root
    ref={ref}
    className={cn(
      'peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border border-border bg-card transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-accent',
      className,
    )}
    {...props}
  >
    {/* O thumb NÃO usa `accent-foreground`: aquele token significa "texto sobre accent", e o
        thumb precisa contrastar com a TRILHA — que muda de cor com o estado (`bg-card`
        desligada, `bg-accent` ligada). Amarrar os dois fazia o thumb desaparecer num dos
        estados sempre: no escuro ele dava 2,65:1 sobre a trilha ligada (mín 3:1 para
        componente gráfico, WCAG 1.4.11). Por estado: 13,9:1 desligado e 6,9:1 ligado. */}
    <RadixSwitch.Thumb className="pointer-events-none block h-5 w-5 rounded-full bg-foreground shadow transition-transform data-[state=checked]:translate-x-5 data-[state=checked]:bg-background data-[state=unchecked]:translate-x-0" />
  </RadixSwitch.Root>
));

Switch.displayName = 'Switch';
